export const GeneralIcon = () => {
	return (
		<div className="location-weather-block-icon">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={ 16 }
				height={ 16 }
				fill="none"
			>
				<g fill="#2F2F2F" clipPath="">
					<path d="M8 11.313A3.316 3.316 0 0 1 4.687 8 3.316 3.316 0 0 1 8 4.687 3.316 3.316 0 0 1 11.313 8 3.316 3.316 0 0 1 8 11.313ZM8 6.25c-.965 0-1.75.785-1.75 1.75S7.035 9.75 8 9.75 9.75 8.965 9.75 8 8.965 6.25 8 6.25Z" />
					<path d="M14.365 8.969a6.47 6.47 0 0 0 0-1.937 2.014 2.014 0 0 0 .72-2.761l-.313-.542a2.034 2.034 0 0 0-2.752-.756 6.468 6.468 0 0 0-1.676-.97A2.033 2.033 0 0 0 8.312 0h-.625c-1.11 0-2.016.896-2.03 2.003a6.469 6.469 0 0 0-1.677.97 2.034 2.034 0 0 0-2.752.756l-.312.542a2.014 2.014 0 0 0 .72 2.76 6.472 6.472 0 0 0 0 1.938 2.034 2.034 0 0 0-.72 2.76l.312.542a2.034 2.034 0 0 0 2.752.756 6.47 6.47 0 0 0 1.676.97A2.034 2.034 0 0 0 7.687 16h.625c1.111 0 2.017-.896 2.032-2.003a6.468 6.468 0 0 0 1.676-.97 2.034 2.034 0 0 0 2.752-.756l.312-.542a2.034 2.034 0 0 0-.72-2.76Zm-.634 1.98-.312.54a.47.47 0 0 1-.64.172l-.462-.266a.782.782 0 0 0-.933.114 4.886 4.886 0 0 1-2.037 1.178.781.781 0 0 0-.566.75v.532a.47.47 0 0 1-.468.469h-.625a.47.47 0 0 1-.47-.47v-.53a.781.781 0 0 0-.565-.752 4.886 4.886 0 0 1-2.037-1.177.782.782 0 0 0-.933-.114l-.461.266a.47.47 0 0 1-.64-.172l-.313-.54a.47.47 0 0 1 .171-.641l.46-.266a.781.781 0 0 0 .368-.865 4.9 4.9 0 0 1 0-2.354.781.781 0 0 0-.367-.865l-.46-.266a.48.48 0 0 1-.172-.64l.312-.541a.47.47 0 0 1 .64-.172l.462.266a.781.781 0 0 0 .933-.114 4.886 4.886 0 0 1 2.037-1.178.781.781 0 0 0 .566-.75V2.03a.47.47 0 0 1 .469-.469h.625a.47.47 0 0 1 .468.47v.53a.781.781 0 0 0 .566.751c.76.218 1.464.626 2.037 1.178a.78.78 0 0 0 .933.115l.461-.267a.47.47 0 0 1 .64.172l.313.54a.48.48 0 0 1-.171.641l-.46.266a.781.781 0 0 0-.368.865 4.898 4.898 0 0 1 0 2.354.782.782 0 0 0 .367.865l.46.266c.225.129.302.416.172.64Z" />
				</g>
				<defs>
					<clipPath id="a">
						<path fill="#fff" d="M0 0h16v16H0z" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export const StyleIcon = () => {
	return (
		<div className="location-weather-block-icon">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={ 16 }
				height={ 16 }
				fill="none"
			>
				<g fill="#2F2F2F" clipPath="">
					<path d="M3.751 9.004a.939.939 0 0 1 0-1.875.939.939 0 0 1 0 1.875Zm4.25-4.25a.939.939 0 0 1 0-1.875.939.939 0 0 1 0 1.875Zm3.005 1.245a.939.939 0 0 1 0-1.875.939.939 0 0 1 0 1.875Zm-6.01 0a.939.939 0 0 1 0-1.875.939.939 0 0 1 0 1.875Z" />
					<path d="M6.754 15.936c-.141 0-.284-.015-.426-.045a8.026 8.026 0 0 1-4.519-2.76A8.015 8.015 0 0 1 .001 8.067c0-2.134.83-4.14 2.338-5.651A7.948 7.948 0 0 1 7.985.066h.016c4.391 0 7.979 3.568 8 7.96v.13a3.821 3.821 0 0 1-1.159 2.706 3.875 3.875 0 0 1-2.725 1.11h-2.24c-.604 0-1.094.491-1.094 1.095v.837c0 .616-.275 1.191-.754 1.579a2.023 2.023 0 0 1-1.275.453ZM8.001 1.629h-.013a6.447 6.447 0 0 0-6.424 6.437c0 3.02 2.14 5.669 5.09 6.297.19.04.327-.042.392-.095a.462.462 0 0 0 .174-.364v-.838a2.66 2.66 0 0 1 2.656-2.656h2.241c1.267 0 2.308-1.019 2.322-2.272v-.104C14.42 4.5 11.534 1.629 8 1.629Z" />
				</g>
				<defs>
					<clipPath id="a">
						<path fill="#fff" d="M0 0h16v16H0z" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export const AdvancedIcon = () => {
	return (
		<div className="location-weather-block-icon">
			<svg xmlns="http://www.w3.org/2000/svg" width={ 16 } height={ 16 }>
				<g clipPath="url(#a)">
					<path d="m14.666 6.667-1.6-.267c-.088-.267-.177-.533-.355-.8l.889-1.333c.178-.178.089-.445-.09-.623L12.267 2.4c-.088-.178-.355-.178-.533 0l-1.333.889c-.267-.178-.534-.267-.8-.356l-.267-1.6C9.244 1.067 9.066.89 8.89.89H7.11a.801.801 0 0 0-.533.533L6.31 2.933c-.267.09-.533.267-.8.356L4.178 2.4a.43.43 0 0 0-.623 0L2.311 3.733c-.178.09-.178.356 0 .623L3.2 5.689c-.09.178-.267.444-.356.8l-1.51.178c-.268.089-.445.266-.445.533v1.778c0 .266.177.444.444.444l1.6.267c.089.267.178.533.356.8l-.89 1.333c-.266.178-.266.445-.088.622l1.333 1.334a.547.547 0 0 0 .622.089l1.334-.89c.266.179.533.267.8.356l.266 1.6c.09.267.267.445.445.445h1.778c.266 0 .444-.178.444-.445l.267-1.6c.266-.089.533-.177.8-.355l1.333.889c.178.177.445.089.622-.09l1.245-1.244a.547.547 0 0 0 .089-.622l-.89-1.333c.179-.267.267-.534.356-.8l1.6-.267c.267-.089.445-.267.445-.444V7.289c-.09-.356-.267-.533-.534-.622Zm-6.666 4a2.58 2.58 0 0 1-2.578-2.578A2.58 2.58 0 0 1 8 5.51a2.58 2.58 0 0 1 2.578 2.578A2.58 2.58 0 0 1 8 10.667Z" />
				</g>
				<defs>
					<clipPath id="a">
						<path d="M0 0h16v16H0z" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};
